import {
  AGE_SEARCH_REACTIVE_MERCH_BANNER_VARIANTS,
  OPTIMIZELY_FLAGS_ENUM,
} from 'src/constants'
import { useOptimizelyDecisionsContext } from 'src/context/optimizely-decisions-context'

interface ReactiveMerchBannerExp {
  shouldShowReactiveMerchBannerExp: boolean
  reactiveMerchBannerVariables: {
    [variableKey: string]: unknown
  }
}

export const useReactiveMerchBannerExperimentValues =
  (): ReactiveMerchBannerExp => {
    const optiContext = useOptimizelyDecisionsContext()

    const shouldShowReactiveMerchBannerExp =
      optiContext?.isExperimentEnabled(
        OPTIMIZELY_FLAGS_ENUM.AGE_SEARCH_REACTIVE_MERCH_BANNER,
      ) &&
      optiContext?.isExperimentVariationKeyOneOf(
        OPTIMIZELY_FLAGS_ENUM.AGE_SEARCH_REACTIVE_MERCH_BANNER,
        AGE_SEARCH_REACTIVE_MERCH_BANNER_VARIANTS,
      )

    const reactiveMerchBannerVariables = optiContext?.getExperimentVariables(
      OPTIMIZELY_FLAGS_ENUM.AGE_SEARCH_REACTIVE_MERCH_BANNER,
    )

    return {
      shouldShowReactiveMerchBannerExp,
      reactiveMerchBannerVariables,
    }
  }
